// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tc-footer {\n  margin: 100px 0 0;\n  padding: 30px;\n  background-color: #f6f8fa;\n  color: #627380;\n  font-size: 0.875rem;\n  text-align: center;\n  box-sizing: border-box;\n}\n", ""]);
// Exports
module.exports = exports;
